import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import Spinner from "../../../component/loadingbar/Spinner";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import Swal from "sweetalert2";
import { triggerNotification } from "../../../component/message/Msg";
import TableViewer from "../../../component/tableViewer/TableViewer";

const ViewQueries = () => {
  const [loading, setLoading] = useState(false);
  const token = config.token;
  const [queryData, setQueryData] = useState({
    query: "",
    name: "",
    queryType: "",
  });
  const navigate = useNavigate();

  const [queries, setQueries] = useState([]);

  //  ------For TableViewer ------
  const queriesRef = useRef([]);
  queriesRef.current = queries;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  useEffect(() => {
    setLoading(true);
    fetch(`${config.host_url}query/query-list`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setQueries(data.data);
        console.log(data.data);
        //  ------For TableViewer ------
        const queriesData = data.data.map((query) => ({
          name: query.first_name + " " + query.last_name,
          query_type: query.query_type,
          query: query.query,
          idNumber: query.qid,
        }));
        setRowData(queriesData);
        //  ------For TableViewer ------

        setLoading(false);
      });
  }, [token]);

  // ------------------------------------------------------------------ Delete query -----------------------------------------------------D
  //   const handleDeleteBtn = (id, i) => {
  //     Swal.fire({
  //       title: "Are you sure?",
  //       text: "You are about to delete query. Are you sure you want to proceed?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#d33",
  //       confirmButtonText: "Yes, delete it!",
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         handleDelete(id, i);
  //       }
  //     });
  //     //Confirm delete
  //     const handleDelete = (id, i) => {
  //       fetch(`${config.host_url}sales-coupon/${id}`, {
  //         method: "DELETE",
  //         headers: {
  //           "Content-Type": "application/json",
  //           token: token,
  //         },
  //       })
  //         .then(function (response) {
  //           return response.json();
  //         })
  //         .then(function (data) {
  //           if (data.status === 200) {
  //             triggerNotification("success", "query deleted successfully");

  //             //  ------For TableViewer ------
  //             const updatedqueries = [...queriesRef.current];
  //             updatedqueries.splice(i, 1);
  //             setQueries(updatedqueries);

  //             const queriesData = updatedqueries.map((query) => ({
  //                 name: query.first_name+" "+query.last_name,
  //                 query_type:query.query_type,
  //                 query:query.query,
  //                 idNumber: query.qid,
  //               }));
  //             setRowData(queriesData);
  //             //  ------For TableViewer ------
  //           } else if (data.status === 404) {
  //             triggerNotification("error", "query not found");
  //           } else if (data.status === 401) {
  //             triggerNotification("error", "Unauthenticated User");
  //           } else {
  //             triggerNotification(
  //               "error",
  //               "Internal server error, Please try after some time!"
  //             );
  //           }
  //         })
  //         .catch(function (error) {
  //           console.error("Error:", error);
  //           triggerNotification("error", "Error deleting query");
  //         });
  //     };
  //   };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "name", filter: true },
    { field: "query_type", filter: true },
    {
      headerName: "query",
      field: "query",
      width: 420,
      cellRenderer: (params) => (
        <div className=" flex py-1 ">
          <p className="p-0 m-0 w-72">
            {params.data.query.length < 44
              ? params.data.query
              : `${params.data.query.slice(0, 44)}...`}
          </p>
          <button
            className="btn btn-xs h-6 mt-2 btn-secondary"
            data-bs-toggle="modal"
            data-bs-target="#showquery"
            onClick={() => {
              setQueryData({
                query: params.data.query,
                name: params.data.name,
                queryType: params.data.query_type,
              });
            }}
          >
            Read more
          </button>
        </div>
      ),
    },
  ];
  //  ------For TableViewer ------
  return (
    <>
      <Breadcrumb txt="Manage Query" subpath={["View Queries"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Queries</h5>
            <div>
              {/* <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                //   navigate("/addquery");
                }}
              >
                Add query
              </button> */}
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3 row mx-4  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                // onDelete={handleDeleteBtn}
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>

      {/* //----------------------------------------------- popup ----------------------------- */}
      <div className="modal " id={`showquery`} tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-simple  modal-lg modal-add-new-cc">
          <div className="modal-content pb-2">
            <div className="modal-body p-md-0">
              <h5 className="card-header p-0 pb-3">Query</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                // onClick={clearSelectedMedia}
              ></button>

              <div className="row border rounded p-2 mb-2">
                <div className="flex justify-between pt-3 pb-2">
                  <div className="flex inline-block items-center">
                    <h6 className="p-0 m-0">Querent:</h6>
                    <span className="pl-2">{queryData?.name}</span>
                  </div>
                  <div className="flex inline-block items-center">
                    <h6 className="p-0 m-0">Query Type: </h6>
                    <span className="pl-2">{queryData?.queryType}</span>
                  </div>
                </div>
                <hr />
                <p>{queryData?.query}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewQueries;
